import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    AddExtraWidget: {
        background: "#f5f6fa",
        fontFamily: "'Inter', sans-serif",
        padding: "17px",
        "& .Btn--Primary": {
            background: "#6E7187",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            // boxShadow: 'none',
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
        },
        "& .BackBtn": {
            border: "none",
            background: "none",
            boxShadow: "none",
            marginRight: "14px",
            cursor: "pointer",
        },
    },
    Item: {
        display: "flex",
        alignItems: "center",
        "& .ItemDetails": {
            marginRight: "auto",
            display: "flex",
            alignItems: "center",
            "& .ItemDetails__Img": {
                marginRight: "12px",
                width: "90px",
                height: "69.38px",
                borderRadius: "8px",
                overflow: "hidden",
                "& img": {
                    width: "100%",
                },
            },
            "& .ItemDetails__Details": {
                "&>div:first-child": {
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "14px",
                    lineHeight: "17px",
                    color: "#271D1C",
                },
                "&>div:last-child": {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "15px",
                    color: "#271D1C",
                },
            },
        },
        "& .AddRemove": {
            display: "flex",
            alignItems: "center",
            background: "#FFFFFF",
            borderRadius: "8px",
            padding: "12px",
            "&>div:nth-child(1)": {
                width: "28px",
                height: "28px",
                background: "#f5f6fa",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
            "&>div:nth-child(2)": {
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "24px",
                lineHeight: "29px",
                textAlign: "center",
                color: "#271D1C",
                width: "30px",
            },
            "&>div:nth-child(3)": {
                width: "28px",
                height: "28px",
                background: "#6E7187",
                borderRadius: "6px",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
            },
        },
    },
    Extras: {
        marginBottom: "24px",
        "& .Extras__Title": {
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#6E7187",
            marginBottom: "12px",
        },
        "& .Extras__Items": {
            background: "#FFFFFF",
            border: "1px solid #e5e9f2",
            borderRadius: "8px",
            padding: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridTemplateRows: "repeat(2, 1fr)",
            gridColumnGap: "8px",
            gridRowGap: "8px",
            "& .Item": {
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                "& .Item__Checkbox": {
                    background: "#FFFFFF",
                    border: "1px solid #6E7187",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "8px",
                },
                "& .Item__Title": {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "17px",
                    color: "#6E7187",
                },
            },
        },
    },
    Notes: {
        marginBottom: "24px",
        "& .Notes__Title": {
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "12px",
        },
        "& .Notes__Content": {
            "& textarea": {
                background: "rgba(251, 253, 245, 0.75)",
                borderRadius: "8px",
                width: "100%",
                padding: "18px",
                border: "none",
                fontFamily: "'Inter'",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "15px",
                "&::placeholder": {
                    color: "rgba(39, 29, 28, 0.5)",
                },
            },
        },
    },
    Container: {
        display: "flex",
        "justify-content": "space-between",
    },
    Customers: {
        width: "400px", // Set your desired fixed width here
        height: "200px", // Set your desired fixed width here
    },
    Input_text: {
        marginBottom: "24px",
        "& .Input_text__Content": {
            minWidth: "280px",
            width: "150px",
            textAlign: "center",
            "& text": {
                background: "rgba(251, 253, 245, 0.75)",
                borderRadius: "4px",
                width: "100%",
                minWidth: "150px",
                padding: "9px",
                border: "none",
                fontFamily: "'Inter'",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "15px",
                "&::placeholder": {
                    color: "rgba(39, 29, 28, 0.5)",
                },
            },
        },
    },
    Input_text__Input: {
        background: "rgba(251, 253, 245, 0.75)",
        borderRadius: "4px",
        width: "90%",
        minWidth: "150px",
        padding: "9px",
        border: "none",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "12px",
        lineHeight: "15px",
    },
    Input_text__InputPlaceholder: {
        color: "rgba(39, 29, 28, 0.5)",
    },
    Actions: {
        display: "flex",
        alignItems: "center",
        "& .Actions_Total": {
            marginRight: "auto",
            "&>div:nth-child(1)": {
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                lineHeight: "15px",
                textTransform: "uppercase",
                color: "#271D1C",
                marginBottom: "9px",
            },
            "&>div:nth-child(2)": {
                "&>span:nth-child(1)": {
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "24px",
                    lineHeight: "29px",
                    textTransform: "uppercase",
                    color: "#271D1C",
                    marginRight: "8px",
                },
                "&>span:nth-child(2)": {
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "12px",
                    lineHeight: "15px",
                    textTransform: "uppercase",
                    color: "#6E7187",
                },
            },
        },
    },
    BtnSave: {
        background: "#6E7187",
        boxShadow:
            "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
        borderRadius: "8px",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "12px",
        lineHeight: "15px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#FFFFFF",
        padding: "16px",
        minWidth: "218px",
        height: "47px",
        border: "none",
    },
    AddPaymentWidget: {
        background: "#f5f6fa",
        padding: "17px",
        "& .Btn--Primary": {
            background: "#6E7187",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            // boxShadow: 'none',
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
        },
        "& .Btn--Secondary": {
            background: "#e14954",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            // boxShadow: 'none',
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
        },
    },
    SmallTablePlaceholderWrapper: {
        marginBottom: "20px",
    },
    CurrencyAmount: {
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
        "& .CurrencyAmount_Currencies": {
            marginRight: "auto",
            display: "flex",
            "& >div": {
                background: "rgba(251, 253, 245, 0.75)",
                padding: "12px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "15px",
                textTransform: "uppercase",
                color: "#271D1C",
                marginRight: "8px",
            },
        },
        "& .CurrencyAmount_OrderAmount": {
            background: "#e5e9f2",
            borderRadius: "8px",
            padding: "4px 8px",
            "&>div:first-child": {
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "10px",
                lineHeight: "12px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#6E7187",
            },
            "&>div:last-child": {
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "19px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#271D1C",
            },
        },
    },
    AmountView: {
        marginBottom: "20px",
        "&>div:first-child": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "&>div:last-child": {
            padding: "15px 24px",
            background: "rgba(251, 253, 245, 0.75)",
            border: "1px solid #e5e9f2",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "22px",
            textTransform: "uppercase",
            color: "#271D1C",
        },
    },
    Keys: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr 1fr",
        gap: "8px 8px",
        marginBottom: "20px",
        "& .Number": {
            background: "#6E7187",
            borderRadius: "8px",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "19px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            padding: "12px",
        },
        "& .Delete": {
            background: "rgba(251, 253, 245, 0.75)",
            borderRadius: "8px",
            textAlign: "center",
            padding: "12px",
            gridColumn: "2/4",
            "& img": {
                margin: "0 auto",
            },
        },
    },
    Tips: {
        marginBottom: "20px",
        "& .Tips__Title": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "& .Tips__Amounts": {
            display: "flex",
            "& .Number": {
                width: "51px",
                height: "47px",
                background: "#6E7187",
                borderRadius: "8px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textAlign: "center",
                lineHeight: "47px",
                marginRight: "4px",
                cursor: "pointer",
                "&.IsSelected": {
                    background: "rgba(251, 253, 245, 0.75)",
                    color: "#271D1C",
                    border: "1px solid #6E7187",
                },
            },
        },
    },
    Discount: {
        marginBottom: "20px",
        "& .Discount__Title": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "& .Discount__Amounts": {
            display: "flex",
            "& .Number": {
                width: "51px",
                height: "47px",
                background: "#6E7187",
                borderRadius: "8px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textAlign: "center",
                lineHeight: "47px",
                marginRight: "4px",
                cursor: "pointer",
                "&.IsSelected": {
                    background: "rgba(251, 253, 245, 0.75)",
                    color: "#271D1C",
                    border: "1px solid #6E7187",
                },
            },
        },
    },
    Change: {
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        padding: "13px 21px",
        background: "#e5e9f2",
        border: "1px solid #e5e9f2",
        justifyContent: "space-between",
        "& .Change__Title": {
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15px",
            textTransform: "uppercase",
            color: "#6E7187",
        },
        "& .Change__Amount": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "24px",
            textTransform: "uppercase",
            color: "#271D1C",
        },
        "& .Change__Currency": {},
    },
    BackdropBlur: {
        backdropFilter: "blur(0.5px)",
    },
}));
